<template>
  <span v-text="value" />
</template>

<script>
export default {
  props: ['value'],
};
</script>
